// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Post-Purchase Analytics Header */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__actions  {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
  width: 100%;
}
.BC-Page.BC-Page__PostPurchaseAnalytics .table-container {
  margin-top: 24px;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .tab-container {
  margin-top: 24px;
}

/* Post-Purchase Analytics - Table Container */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container {
  width: 100%;
  border-radius: 4px;
  overflow: auto;
}

/* Post-Purchase Analytics - Filter Section */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__filter-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 8px 0;
}

/* Post-Purchase Analytics - Table Footer */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Footer {
  padding: 16px;
  text-align: center;
  border-top: 1px solid #e8e9eb;
  color: #6d7175;
}

/* Post-Purchase Analytics - Table Header */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__HeaderCell {
  background: #fafbfb;
  padding: 12px 16px;
  border-bottom: 1px solid #e8e9eb;
  font-weight: 600;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__HeaderCell button {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: inherit;
  font-weight: inherit;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__HeaderCell button:hover {
  color: #008060;
}

/* Post-Purchase Analytics - Table Cell */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Cell {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Table .Polaris-DataTable__Icon {
  display: none;
}

/* Post-Purchase Analytics - Table Row */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__BodyRow:hover {
  background: #f9fafb;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .header-with-tooltip {
  display: flex;
  align-items: center;
  gap: 2px;
  justify-content: flex-end;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .header-with-sortable {
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .arrow {
  min-width: 12px;
  height: 12px;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .asc-arrow {
  transform: rotate(180deg);
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Heading {
  margin: 0;
  padding: 0;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .product-link {
  text-decoration: none;
}

/* Post-Purchase Analytics - Tooltip Container */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__tooltip-icon {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__tooltip-icon .Polaris-Icon {
  width: 12px;
  height: 12px;
  color: #6d7175;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__tooltip-icon .Polaris-Icon:hover {
  color: #008060;
}

/* Post-Purchase Analytics - Loading State */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
}

/* Post-Purchase Analytics - Empty State */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  background: #fafbfb;
  border-radius: 4px;
  text-align: center;
}

/* Post-Purchase Analytics - Modal */
.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__modal-content {
  padding: 0;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__modal-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #e8e9eb;
}

.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/post-purchase-analytics.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/* Post-Purchase Analytics Header */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__actions  {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 16px 0;\n  width: 100%;\n}\n.BC-Page.BC-Page__PostPurchaseAnalytics .table-container {\n  margin-top: 24px;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .tab-container {\n  margin-top: 24px;\n}\n\n/* Post-Purchase Analytics - Table Container */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container {\n  width: 100%;\n  border-radius: 4px;\n  overflow: auto;\n}\n\n/* Post-Purchase Analytics - Filter Section */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__filter-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 8px 0;\n}\n\n/* Post-Purchase Analytics - Table Footer */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Footer {\n  padding: 16px;\n  text-align: center;\n  border-top: 1px solid #e8e9eb;\n  color: #6d7175;\n}\n\n/* Post-Purchase Analytics - Table Header */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__HeaderCell {\n  background: #fafbfb;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e8e9eb;\n  font-weight: 600;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__HeaderCell button {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  color: inherit;\n  font-weight: inherit;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__HeaderCell button:hover {\n  color: #008060;\n}\n\n/* Post-Purchase Analytics - Table Cell */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Cell {\n  padding: 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Table .Polaris-DataTable__Icon {\n  display: none;\n}\n\n/* Post-Purchase Analytics - Table Row */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__BodyRow:hover {\n  background: #f9fafb;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .header-with-tooltip {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  justify-content: flex-end;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .header-with-sortable {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  cursor: pointer;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .arrow {\n  min-width: 12px;\n  height: 12px;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .asc-arrow {\n  transform: rotate(180deg);\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .Polaris-DataTable__Heading {\n  margin: 0;\n  padding: 0;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__table-container .product-link {\n  text-decoration: none;\n}\n\n/* Post-Purchase Analytics - Tooltip Container */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__tooltip-icon {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 4px;\n  cursor: help;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__tooltip-icon .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n  color: #6d7175;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__tooltip-icon .Polaris-Icon:hover {\n  color: #008060;\n}\n\n/* Post-Purchase Analytics - Loading State */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n}\n\n/* Post-Purchase Analytics - Empty State */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n  background: #fafbfb;\n  border-radius: 4px;\n  text-align: center;\n}\n\n/* Post-Purchase Analytics - Modal */\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__modal-content {\n  padding: 0;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__modal-footer {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  padding-top: 16px;\n  border-top: 1px solid #e8e9eb;\n}\n\n.BC-Page.BC-Page__PostPurchaseAnalytics .post-purchase-analytics__pagination-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
